export default __webpack_public_path__ + "static/media/NamesAlbumCover990x990.807af348.jpg";